<script setup lang="ts">
import {computed} from "vue";
import type {ICellRendererParams} from "ag-grid-community";

const props = defineProps<{ params: ICellRendererParams & {rendererOptions?: any; colId?: string} }>();

function resolveColId(): string | undefined {
  return props.params.colId ?? props.params.column?.getColId();
}

const cell = computed(() => {
  const data: any = props.params.data;
  const colId = resolveColId();
  if (!data || !colId) return null;
  return data.cells?.[colId] ?? null;
});

const rawHtml = computed(() => String(cell.value?.displayValue ?? cell.value?.value ?? props.params.value ?? ''));
</script>

<template>
  <span class="bi-html-cell" v-html="rawHtml"/>
</template>

<style scoped>
.bi-html-cell {
  display: inline-block;
  width: 100%;
  line-height: 1.4;
}
</style>
